import React from 'react'

import styles from './_app-loader.module.scss'
import { Spinner } from '../..//module'

// TODO: Finalize these loading messages and then add them to translations
const LOADING_MESSAGES = [
  'Loading your data feast... please hold the appetizers!',
  "Gathering the data wizards... they're a bit slow today!",
  'Data in transit... please fasten your seatbelt!',
  "We're diving deep into the data ocean... hold tight!",
  "Fetching your insights... it's a data treasure hunt!",
  'Loading... just a moment while we polish the data gems!',
  'Preparing your data symphony... the orchestra is tuning up!',
  'Data loading in progress... please enjoy this brief intermission!',
  "We're on a data expedition... exploring the depths of your information!",
  "Just a moment... we're aligning the stars of your data!",
  "Loading your insights... it's like waiting for a fine wine to breathe!",
  "Hang tight! We're assembling your data puzzle pieces!",
  'Data loading... think of it as a coffee break for your insights!',
  "We're crafting your data masterpiece... art takes time!",
]

const AppLoader = ({
  qaTestId = 'app-loader',
}: {
  /** Optional prop to add a test id to the AppLoader for QA testing */
  qaTestId?: string
}): React.JSX.Element => {
  const randomMessage =
    LOADING_MESSAGES[Math.floor(Math.random() * LOADING_MESSAGES.length)]

  return (
    <div className={styles.appLoader} qa-test-id={qaTestId}>
      <Spinner size='large' />
      <div>{randomMessage}</div>
    </div>
  )
}

export default AppLoader
